import {
    AnyAction,
    Middleware,
    MiddlewareAPI,
    ThunkDispatch,
} from '@reduxjs/toolkit'
import {ModalActionType} from '../actions/modal/types'
import type {RootState} from '../store'
import {toggleModalState} from '../state/ui'

type AsyncThunkDispatch = ThunkDispatch<RootState, undefined, AnyAction>

export const modalMiddleware: Middleware = (store: MiddlewareAPI<AsyncThunkDispatch>) => (next) => (action) => {
    // Check if the action is a modal action
    if (Object.values(ModalActionType).includes(action.type)) {
        const {show} = action.meta
        store.dispatch(toggleModalState(show))
    }
    // Pass the action to the next middleware or reducer
    return next(action)
}
